<script setup lang="ts">
import BaseLabel from '@/atoms/BaseLabel.vue';
import { cva } from 'class-variance-authority';
import { computed } from 'vue';
import { cn } from '@/helpers/tailwind-helpers';
import { InputState } from '@/atoms/BaseInput.vue';

export type InputWrapperProps = {
  id: string;
  destructive?: boolean;
  required?: boolean;
  label?: string;
  hint?: string;
  class?: string;
  error?: string;
  state?: InputState;
  type?: string;
  autocomplete?: string;
};

const inputWrapper = cva('flex flex-col space-y-1', {
  variants: {
    state: {
      default: 'text-placeholder',
      filled: 'text-primary',
      focused: 'placeholder-brand-solid border-brand-solid text-primary',
      disabled: 'text-disabled placeholder-disabled fill-disabled',
      hover: '',
    },
    destructive: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [],
  defaultVariants: {
    state: 'default',
  },
});

const props = defineProps<InputWrapperProps>();

const classes = computed(() => cn(inputWrapper(props), props.class));
</script>

<template>
  <div :class="classes">
    <span>
      <BaseLabel v-if="label" color="secondary" :text="label" />
      <BaseLabel class="ml-1" v-if="required" color="brand" text="*" />
    </span>

    <slot v-bind="props" />

    <BaseLabel
      preset="small"
      :color="destructive ? 'error' : 'tertiary'"
      v-if="hint && !error"
      :text="hint"
    />

    <BaseLabel :data-cy="`error-${id}`" preset="small" color="error" v-if="error" :text="error" />
  </div>
</template>

<style scoped></style>
